import { BellNotification } from 'iconoir-react';
import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';

import { Tooltip } from '@savgroup-front-common/core/atoms/Tooltip';
import {
  safeFormattedIntlString,
  SafeFormattedMessageWithoutSpread,
} from '@savgroup-front-common/core/formatters';
import { AppScheduledMaintenance } from '@savgroup-front-common/types';

import {
  $ToastLink,
  $ToastTime,
} from './InProgressScheduledMaintenance.styles';
import messages from './messages';

interface InProgressScheduledMaintenanceProps {
  scheduledMaintenance: AppScheduledMaintenance;
}

const InProgressScheduledMaintenance: FunctionComponent<
  InProgressScheduledMaintenanceProps
> = ({ scheduledMaintenance }) => {
  const { formatDate } = useIntl();

  return (
    <>
      {scheduledMaintenance.incidentUpdates[0].body}

      <$ToastTime>
        <SafeFormattedMessageWithoutSpread
          message={messages.scheduledUntil}
          values={{
            time: formatDate(scheduledMaintenance.scheduledUntil, {
              day: 'numeric',
              month: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            }),
          }}
        />

        <Tooltip content={safeFormattedIntlString(messages.seemore)}>
          <$ToastLink
            href={scheduledMaintenance.shortlink}
            isExternal
            target="_blank"
          >
            <BellNotification />
          </$ToastLink>
        </Tooltip>
      </$ToastTime>
    </>
  );
};

export default InProgressScheduledMaintenance;
